"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnConfigs = exports.employeeDisplayProperties = void 0;
exports.filterForPermissions = filterForPermissions;
exports.hasAnyRequiredPermissions = hasAnyRequiredPermissions;
exports.filterForEnabled = filterForEnabled;
exports.getRequiredContext = getRequiredContext;
exports.precompileColumnOptions = precompileColumnOptions;
exports.getTable = getTable;
exports.getTableHeaders = getTableHeaders;
exports.getTableSubHeaders = getTableSubHeaders;
exports.serializeColumOptions = serializeColumOptions;
exports.deserializeColumOptions = deserializeColumOptions;
const config_1 = require("./config");
var config_2 = require("./config");
Object.defineProperty(exports, "employeeDisplayProperties", { enumerable: true, get: function () { return config_2.employeeDisplayProperties; } });
Object.defineProperty(exports, "columnConfigs", { enumerable: true, get: function () { return config_2.columnConfigs; } });
function filterForPermissions(checkPermission, columnOptions) {
    return columnOptions.filter((column) => {
        const config = config_1.columnConfigs[column.type];
        return !config.requiredPermissions || config.requiredPermissions.some(checkPermission);
    });
}
/**
 * checks if there is any column that satisfies all required permissions
 */
function hasAnyRequiredPermissions(checkPermission) {
    return config_1.employeeDisplayProperties.some((type) => {
        const config = config_1.columnConfigs[type];
        if (!config.requiredPermissions || !config.requiredPermissions.length)
            return true;
        return config.requiredPermissions.every(checkPermission);
    });
}
function filterForEnabled(columnOptions) {
    return columnOptions.filter((column) => !column.disabled && !config_1.columnConfigs[column.type].disabled);
}
function getRequiredContext(columnOptions) {
    const requirements = new Set();
    for (const column of columnOptions) {
        const config = config_1.columnConfigs[column.type];
        if (config.requiredContext) {
            for (const requirement of config.requiredContext) {
                requirements.add(requirement);
            }
        }
    }
    return requirements;
}
function precompileColumnOptions(context, columnOptions) {
    const compiledOptions = [];
    for (const option of columnOptions) {
        const config = config_1.columnConfigs[option.type];
        const precompiler = config.preCompile;
        if (precompiler) {
            const options = precompiler(context);
            compiledOptions.push(...options);
        }
        else {
            compiledOptions.push(option);
        }
    }
    return compiledOptions;
}
function getTable(contexts, columns) {
    const table = new Array(contexts.length);
    for (const i in contexts) {
        table[i] = new Array(columns.length);
        for (const j in columns) {
            const column = columns[j];
            const getValue = config_1.columnConfigs[column.type].getValue;
            table[i][j] = getValue ? getValue(contexts[i], column) : "Nicht unterstützt";
        }
    }
    return table;
}
function getTableHeaders(columns) {
    return columns.map((column) => config_1.columnConfigs[column.type].getHeader());
}
function getTableSubHeaders(context, columns) {
    return columns.map((column) => {
        const getSubHeaderFn = config_1.columnConfigs[column.type].getSubHeader;
        return getSubHeaderFn ? getSubHeaderFn(context, column) : "";
    });
}
function serializeColumOptions(options) {
    return btoa(JSON.stringify(options)).replace(/=/g, "");
}
function deserializeColumOptions(options) {
    if (!options)
        return [];
    return JSON.parse(atob(options));
}
//# sourceMappingURL=employee-table.js.map